﻿import { defineStore } from 'pinia';

export const useSofDragDropStore = defineStore('sofDragDropModule', {
    state: () => ({
        _hasInitialisedHtml5DragDropPollyfill: false
    }),
    getters: {
        hasInitialisedHtml5DragDropPollyfill: state => state._hasInitialisedHtml5DragDropPollyfill
    },
    actions: {
        setInitialisedHtml5DragDropPollyfill(): void {
            this._hasInitialisedHtml5DragDropPollyfill = true;
        }
    }
});

export type SofDragDropModule = ReturnType<typeof useSofDragDropStore>;

export default useSofDragDropStore;
